import React, { useState, useEffect, useRef, useCallback } from "react";
import { Row, Col, Container, Card } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import "../assets/css/Home.css";
import SEO from "../components/SEO";
import flowerBW from "../assets/images/flower_bw.svg";
import animat_video from "../assets/images/animation_video.mp4";
import animation_video from "../assets/images/animat_video.mp4";
import playbtn from "../assets/images/next.svg";
import difbundle from "../assets/images/difbundle.svg";
import halfround from "../assets/images/gifbg.png";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { useVisualImageSearch } from "../hooks/useVisualImageSearch";
import api from "../api/axios";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { TabView, TabPanel } from "primereact/tabview";
import ProtectedCanvasImage from "../components/ProtectedCanvasImage";

const bannerImages = [
  "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/Banner1v2%20Change.mp4",
  "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/Newbann%202%20low.mp4",
  // "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/banner2.png",
  // "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/banner12.png",
];

/*-------------tabs data--------------*/
const tabs = [
  {
    id: "01",
    title: "Exclusively created in-house.",
    desc: "Every element is illustrated by us, not scraped, resold, or repeated across marketplaces. Your designs stay original.",
    color: "#fff",
  },
  {
    id: "02",
    title: "A Massive Library That Covers It All",
    desc: "A comprehensive collection of illustrated assets for weddings, occasions, branding, social media, and beyond.",
    color: "#00665B",
  },
  {
    id: "03",
    title: "Unlimited downloads with one simple subscription.",
    desc: "Download what you need, when you need it, without counting credits or worrying about extra costs.",
    color: "#fff",
  },
  {
    id: "04",
    title: "Exclusively created in-house.",
    desc: "Every element is illustrated by us, not scraped, resold, or repeated across marketplaces. Your designs stay original.",
    color: "#FFADD8",
  },
];

/*-------------Insta Video--------------*/

const designItems = [
  {
    title: "Building Shaadi Material",
    video:
      "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/1.mp4",
  },
  {
    title: "Unapologetically Indian",
    video:
      "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/2.mp4",
  },
  {
    title: "What We Offer",
    video:
      "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/3.mp4",
  },
  {
    title: "Elements Showcase",
    video:
      "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/4.mp4",
  },
  {
    title: "Making Your Life Easier",
    video:
      "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/5.mp4",
  },
];

const NewmainHome = () => {
  const navigate = useNavigate();
  const toast = useRef(null);
  const onVisualResults = useCallback(
    (data) => {
      navigate("/shop", {
        state: { visualSearchApplied: true, visualSearchResults: data },
      });
    },
    [navigate],
  );

  const { fileInputRef, visualLoading, runVisualSearch } = useVisualImageSearch(
    toast,
    {
      onResults: onVisualResults,
    },
  );

  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState({
    category_name: "",
    category_id: 0,
  });
  const [search, setSearch] = useState("");
  const [fixedSearch, setFixedSearch] = useState(false);
  const [homeOccasions, setHomeOccasions] = useState([]);
  const [homeBundles, setHomeBundles] = useState([]);


  useEffect(() => {
    const fetchOccasionsForHome = async () => {
      try {
        const res = await api.get(
          "/OccasionRoutes/public/fetch_occasions_for_home",
        );
        setHomeOccasions(res?.data?.data || []);
      } catch (e) {
        console.warn("Failed to fetch occasions for home:", e?.message || e);
        setHomeOccasions([]);
      }
    };

    fetchOccasionsForHome();
  }, []);

  useEffect(() => {
    const fetchHomeBundles = async () => {
      try {
        const res = await api.get("/pbundles/customer/home-bundles");
        setHomeBundles(res?.data?.data || []);
      } catch (e) {
        console.warn("Failed to fetch home bundles:", e?.message || e);
        setHomeBundles([]);
      }
    };

    fetchHomeBundles();
  }, []);



  const goToShopWithCategory = useCallback(
    (categoryName) => {
      navigate("/shop", {
        state: {
          searchTerm: "",
          category: categoryName || "",
        },
      });
    },
    [navigate],
  );

  // When user searches from Home, carry the same term to Shop's search box.
  const goToShopWithSearch = useCallback(() => {
    const term = search.trim();

    navigate("/shop", {
      state: {
        searchTerm: term,
        category: category?.category_name || "",
      },
    });
  }, [navigate, search, category]);

  const searchRef = useRef(null);

  /* scroll detection */

  useEffect(() => {
    const handleScroll = () => {
      if (!searchRef.current) return;

      const offset = searchRef.current.offsetTop;

      if (window.scrollY > offset) {
        setFixedSearch(true);
      } else {
        setFixedSearch(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [active, setActive] = useState(0);

  /*-----------------Scroll trigger--------------*/

  useEffect(() => {
    const section = document.querySelector(".category-part");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add("animate");
          }
        });
      },
      { threshold: 0.4 },
    );

    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

useEffect(() => {
  const fetchCategories = async () => {
    try {
      const response = await api.get("/CategoryRoutes/customer/categories");

      if (response.status === 200 && response.data.success) {
        setCategories(response.data.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch categories:", error);
      setCategories([]);
    }
  };

  fetchCategories();
}, []);

  const getBundleImage = (bundle) => {
    if (!bundle?.images?.length) return difbundle;

    const sorted = [...bundle.images].sort(
      (a, b) => (a.order_no || 0) - (b.order_no || 0),
    );

    return sorted[0]?.image_url || difbundle;
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) runVisualSearch(f);
        }}
      />
      <Toast ref={toast} position="top-center" />
      <SEO
        title="Home"
        description="Browse premium stock images, wallpapers, and digital assets."
        canonical="https://shaadimaterial.com/shop"
        keywords="stock images, wallpapers, digital assets"
        image="https://shaadimaterial.com/logo192.png"
      />

      <div className="wrapper p-0">
        <section className="banner-part">
          {/* Full Width Background Video */}
          <Swiper
            loop={true}
            speed={2000}
            autoplay={{
              delay: 4200,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper videoswiper"
          >
            {bannerImages.map((image, index) => (
              <SwiperSlide key={index}>
                <video
                  className="banner-video-bg"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                >
                  <source src={image} type="video/mp4" />
                </video>
              </SwiperSlide>
            ))}
          </Swiper>
          {/* <video
            className="banner-video-bg"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          >
            <source src={animation_video} type="video/mp4" />
          </video>

          <Container>

            <Row className="mx-0 banner">

              <Col md={12} className="text-center">
                <div className="resphide">
                  <h1 data-aos="fade-down" data-aos-delay="120">
                    We Fully Support <br /> Being <span>Materialistic.</span>
                  </h1>

                  <p data-aos="fade-up" data-aos-delay="120">Especially when it comes to design.</p>
                </div>
                <div
                  ref={searchRef}
                  className={`search-wrapper ${fixedSearch ? "search-fixed" : ""}`}
                >

                  <div className="search-container" data-aos="fade-up" data-aos-delay="220">

                    <Dropdown
                      value={category}
                      options={categories}
                      optionLabel={(cat) => (cat.category_name === "" ? "All" : cat.category_name)}
                      onChange={(e) => setCategory(e.value)}
                      placeholder={`Search ${category?.category_name || "All"}...`}
                      className="search-dropdown"
                    />

                    <InputText
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search Photos..."
                      className="search-input"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") goToShopWithSearch();
                      }}
                    />

                    <div className="home-hero-search-actions">
                      <i
                        className="pi pi-search search-icon"
                        aria-hidden
                        onClick={goToShopWithSearch}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") goToShopWithSearch();
                        }}
                      />
                    </div>

                  </div>

                </div> 

              </Col>

            </Row>

          </Container> */}
        </section>
        {/*---------End_Banner--------------*/}

        {/*---------Start_Category--------------*/}
        <section className="category-part">
          <Container>
            <Row className="mx-0 category">
              <Col md={12} className="text-center">
                <p data-aos="fade-down" data-aos-delay="120">
                  Products by Categories
                </p>
                <h2 data-aos="fade-up" data-aos-delay="120">
                  Find the <span>products</span> you need
                </h2>
              </Col>
              <Col md={12} className="text-center mt-5">
                <ul>
                  {(categories.length > 0
                    ? categories
                    : Array.from({ length: 9 })
                  ).map((item, index) => {
                    const categoryName = item?.category_name || "-";
                    const categoryImage = item?.image_url || flowerBW;

                    return (
                      <li
                        key={
                          item?.category_id || `category-placeholder-${index}`
                        }
                        data-aos="fade-up"
                        data-aos-delay={index * 120}
                        onClick={() =>
                          item && goToShopWithCategory(categoryName)
                        }
                        style={{ cursor: item ? "pointer" : "default" }}
                      >
                        <img src={categoryImage} alt={categoryName} />
                        <h4>{categoryName}</h4>
                      </li>
                    );
                  })}
                </ul>
              </Col>
            </Row>
          </Container>
        </section>
        {/*---------End_Category--------------*/}

        {/*---------Start_Stickypart--------------*/}
        <section className="sticky-part">
          <Container className="p-0">
            <Row className="mx-0">
              <div className="mainSticky">
                <div className="card one">
                  <h4 data-aos="fade-down" data-aos-delay="120">
                    Looking for <br />
                    wedding elements? <span>You’ll find them here.</span>
                  </h4>
                </div>
                <div className="card two">
                  <h4 data-aos="fade-up" data-aos-delay="120">
                    Need <br />
                    illustrations? <span>Scroll a little.</span>
                  </h4>
                </div>
                <div className="card three">
                  <h4 data-aos="fade-up" data-aos-delay="120">
                    Caricatures <br /> on your list? <span>Got those too.</span>
                  </h4>
                </div>
                <div className="card four">
                  <h4 data-aos="fade-up" data-aos-delay="120">
                    Backdrops to <br />
                    set the mood? <span>Plenty.</span>
                  </h4>
                </div>
                <div className="card five">
                  <h4 data-aos="fade-up" data-aos-delay="120">
                    A full invite with
                    <br /> everything included? <span>Done.</span>
                  </h4>
                </div>
                <div className="card six">
                  <h4 data-aos="fade-up" data-aos-delay="120">
                    Everything’s covered. <span>Except the partner.</span>
                    <span>That part’s on you.</span>
                  </h4>
                </div>
              </div>
            </Row>
          </Container>
        </section>

        {/*---------End_Stickypart--------------*/}

        {/*---------Start_Gif_animation--------------*/}
        <section className="gif-part overflow-hidden curved-section">
          {/* Background Video */}
          <video className="bg-video" autoPlay loop muted playsInline>
            <source src={animat_video} type="video/mp4" />
          </video>
          <Container className="p-0">
            <Row className="mx-0 justify-content-center">
              <Col
                md={4}
                lg={3}
                className="text-center border-end"
                data-aos="fade-right"
                data-aos-delay="120"
              >
                <h4>Everything’s covered.</h4>
              </Col>
              <Col
                md={4}
                lg={3}
                className="text-center"
                data-aos="fade-up"
                data-aos-delay="420"
              >
                <h4>Except the partner.</h4>
              </Col>
              <Col
                md={4}
                lg={3}
                className="text-center border-start"
                data-aos="fade-left"
                data-aos-delay="720"
              >
                <h4>That part’s on you.</h4>
              </Col>
            </Row>
          </Container>
        </section>

        {/*---------start_monthspacial--------------*/}
        {homeOccasions.length > 0 && (
          <section className="monthspacial mb-lg-5">
            {/* <div className="roundcercle">
      <img src={halfround} alt="flower"/>
    </div> */}

            <Container className="p-0">
              <Row className="mx-0">
                <Col md={12} className="text-center mb-5 p-0">
                  <h2 data-aos="fade-up" data-aos-delay="120">
                    Month Special
                  </h2>
                </Col>

                <Col md={12} className="p-0 mt-5 homeslider">
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={30}
                    pagination={{
                      type: "fraction",
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                    data-aos="fade-up"
                    data-aos-delay="420"
                    breakpoints={{
                      320: {
                        slidesPerView: 2.1,
                        spaceBetween: 10,
                      },
                      576: {
                        slidesPerView: 2.1,
                        spaceBetween: 15,
                      },
                      768: {
                        slidesPerView: 3.1,
                        spaceBetween: 20,
                      },
                      992: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                      },
                      1200: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                      },
                    }}
                  >
                    {homeOccasions.map((o, idx) => (
                      <SwiperSlide key={`home-occasion-${o.id || idx}`}>
                        <div className="imageSldiv">
                          <ProtectedCanvasImage
                            src={o.cover_image_url || flowerBW}
                            alt={o.occasion_name || "occasion"}
                            width="100%"
                            height="100%"
                            objectFit="cover"
                            objectPosition="center center"
                          />
                        </div>

                        <h6>{o.occasion_name}</h6>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              </Row>
            </Container>
          </section>
        )}

        {/*---------Start_elements_form--------------*/}

        <section className="elementsForm mt-lg-5">
          <Container className="p-0 pb-100">
            <Row className="mx-0 elementsdiv">
              <Col md={12} className="text-center mb-5 p-0">
                <h2 data-aos="fade-up" data-aos-delay="120">
                  Why Get Your <br /> Elements From Us
                </h2>
              </Col>
              <Col md={12} className="p-0 mt-5">
                <div className="tabs-section">
                  <div className="tabs-wrapper">
                    <div className="tab-heads">
                      {tabs.map((tab, index) => (
                        <div
                          key={index}
                          className={`tab-head ${active === index ? "active" : ""}`}
                          onClick={() => setActive(index)}
                        >
                          {tab.id}.
                        </div>
                      ))}
                    </div>

                    <div
                      className="tab-content"
                      style={{
                        background: tabs[active].color,
                        color: active === 1 ? "#fff" : "#000",
                      }}
                    >
                      <span
                        className="big-number"
                        data-aos="fade-up"
                        data-aos-delay="120"
                        style={{
                          borderBottom: `1px dashed ${active === 1 ? "#fff" : "#000"}`,
                        }}
                      >
                        {tabs[active].id}.
                      </span>

                      <h3 data-aos="fade-up" data-aos-delay="120">
                        {tabs[active].title}
                      </h3>

                      <p data-aos="fade-up" data-aos-delay="120">
                        {tabs[active].desc}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/*---------Start_designs_stand--------------*/}
        <section className="designsStand pt-4">
          <Container className="p-0">
            <Row className="mx-0 Stand_div">
              <Col md={12} className="text-center mb-5 d-block p-0">
                <h2 data-aos="fade-up" data-aos-delay="120">
                  Elements that make <br />
                  your <span>designs stand out</span>
                </h2>
              </Col>
              <Col md={12} className="p-0 ">
                <ul className="design-grid">
                  {designItems.map((item, index) => (
                    <li
                      key={index}
                      data-aos="fade-up"
                      data-aos-delay={index * 120}
                      data-aos-duration="900"
                    >
                      <div className="desdiv">
                        <video
                          src={item.video}
                          autoPlay
                          muted
                          loop
                          playsInline
                        />
                      </div>

                      <div className="descontent">
                        <p>{item.title}</p>

                        <span>
                          <a
                            href="https://www.instagram.com/shaadimaterial"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={playbtn} alt="View on Instagram" />
                          </a>
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </Container>
        </section>

        {/*---------Start_Bundle--------------*/}

        {homeBundles.length > 0 && (
          <section className="BundleForm">
            <Container className="p-0">
              <Row className="mx-0 Bundlediv">
                <Col md={12} className="text-center mb-5 p-0">
                  <h2 data-aos="fade-up" data-aos-delay="120">
                    All in one bundle
                  </h2>
                </Col>

                <Col md={12} className="text-center p-0">
                  <ul>
                    {homeBundles.map((bundle) => (
                      <li
                        key={bundle.product_bundle_id}
                        onClick={() =>
                          navigate(
                            `/bundleproductdetails/${bundle.product_bundle_id}`,
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <ProtectedCanvasImage
                          src={getBundleImage(bundle)}
                          alt={bundle.bundle_name || "bundle"}
                          width="100%"
                          height="100%"
                          objectFit="cover"
                          objectPosition="center center"
                        />

                        <Button
                          label={bundle.bundle_name || "BUNDLE"}
                          className="bundlebutton"
                        />
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </Container>
          </section>
        )}
      </div>
    </>
  );
};

export default NewmainHome;
